<div class="page-layout simple fullwidth inner-scroll">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <button
                *ngIf="esSupervisor"
                mat-icon-button
                class="mr-0 mr-sm-16"
                [routerLink]="'/clientes'"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div
                *ngIf="cliente"
                fxLayout="column"
                fxLayoutAlign="start start"
                [@animate]="{
                    value: '*',
                    params: { delay: '100ms', x: '-25px' }
                }"
            >
                <div class="h2">CLIENTE - {{ cliente.nombre }}</div>

                <div class="subtitle secondary-text">
                    <span>{{ cliente.rut }}</span>
                </div>
            </div>

        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="content" fusePerfectScrollbar>
        <mat-tab-group dynamicHeight="true">
            <mat-tab [label]="etiquetas.ficha" *ngIf="esSupervisor">
                <div class="p-24">
                    <app-ficha-cliente
                        *ngIf="cliente"
                        (eliminarCliente)="eliminarCliente($event)"
                        (editarCliente)="editarCliente($event)"
                        (toggleEstadoClienteEvent)="
                            cambiarEstadoCliente($event)
                        "
                        [data]="cliente"
                    ></app-ficha-cliente>
                </div>
            </mat-tab>
            <mat-tab [label]="etiquetas.representantes" *ngIf="esSupervisor">
                <div class="p-24">
                    <app-representantes
                        *ngIf="representantes"
                        [representantes]="representantes"
                        [idCliente]="idCliente"
                        (borrarRepresentante)="borrarRepresentante($event)"
                        (editarRepresentante)="editarRepresentante($event)"
                    ></app-representantes>
                </div>

                <button
                    *ngIf="esSupervisor"
                    mat-fab
                    class="accent"
                    id="agregar-representante-button"
                    (click)="nuevoRepresentante()"
                    aria-label="Nuevo representante"
                    [@animate]="{
                        value: '*',
                        params: { delay: '300ms', scale: '.2' }
                    }"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </mat-tab>
            <mat-tab [label]="etiquetas.sucursales">
                <div class="p-24">
                    <app-sucursales
                        *ngIf="sucursales"
                        [sucursales]="sucursales"
                        [esSupervisor]="esSupervisor"
                        [esRepresentante]="esRepresentante"
                        [esEncargado]="esEncargado"
                        (borrarSucursal)="borrarSucursal($event)"
                        (editarSucursal)="editarSucursal($event)"
                        (verEncargadosSucursal)="verEncargados($event)"
                    >
                    </app-sucursales>
                </div>

                <button
                    *ngIf="esRepresentante || esSupervisor"
                    mat-fab
                    class="accent"
                    id="agregar-sucursal-button"
                    (click)="nuevaSucursal()"
                    aria-label="Nueva sucursal"
                    [@animate]="{
                        value: '*',
                        params: { delay: '300ms', scale: '.2' }
                    }"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </mat-tab>
        </mat-tab-group>
    </div>
    <!--</div>-->

    <!-- / CONTENT -->
</div>
